import moment from "moment";

export default class BundleReport {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.airlineCode = data.airlineCode || undefined;
        this.channel = data.channel || undefined;
        this.checkInDate = data.checkInDate ? moment.utc(data.checkInDate) : undefined;
        this.checkOutDate = data.checkOutDate ? moment.utc(data.checkOutDate) : undefined;
        this.couponCode = data.couponCode || undefined;
        this.couponValue = data.couponValue || undefined;
        this.createdAt = data.createdAt ? moment.utc(data.createdAt) : null;
        this.createdDate = data.createdDate ? moment.utc(data.createdDate) : null;
        this.customerId = data.customerId || undefined;
        this.email = data.email || undefined;
        this.emailCustomer = data.emailCustomer || undefined;
        this.endPoint = data.endPoint || undefined;
        this.fullname = data.fullname || undefined;
        this.fullnameCustomer = data.fullnameCustomer || undefined;
        this.hotelId = data.hotelId || null;
        this.hotelName = data.hotelName || null;
        this.id = data.id || undefined;
        this.markUpPriceRoom = data.markUpPriceRoom || undefined;
        this.memberShipCode = data.memberShipCode || undefined;
        this.note = data.note || undefined;
        this.orderCode = data.orderCode || undefined;
        this.orderId = data.orderId || undefined;
        this.orderItemType = data.orderItemType || undefined;
        this.orderStatus = data.orderStatus || undefined;
        this.paymentStatus = data.paymentStatus || undefined;
        this.paymentType = data.paymentType || undefined;
        this.phoneNumber = data.phoneNumber || undefined;
        this.phoneNumberCustomer = data.phoneNumberCustomer || undefined;
        this.pnr = data.pnr || undefined;
        this.priceRoom = data.priceRoom || undefined;
        this.quickTaskStatus = data.quickTaskStatus || undefined;
        this.ratePlanId = data.ratePlanId || null;
        this.ratePlanName = data.ratePlanName || null;
        this.roomType = data.roomType || null;
        this.roomTypeId = data.roomTypeId || null;
        this.saleChannel = data.saleChannel || undefined;
        this.salePrice = data.salePrice || undefined;
        this.startPoint = data.startPoint || undefined;
        this.subTotal = data.subTotal || undefined;
        this.surcharge = data.surcharge || undefined;
        this.surchargeDetail = data.surchargeDetail || undefined;
        this.ticketPrice = data.ticketPrice || undefined;
        this.totalAmount = data.totalAmount || undefined;
        this.totalMarkUpTicket = data.totalMarkUpTicket || undefined;
        this.transactionId = data.transactionId || undefined;
        this.dataList = data.dataList || [];
    }
}